import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { BuyButton } from "./BuyButton";

const FAQS = [
  {
    q: "Who is the Train-the-Trainer Toolkit for?",
    a: "Consultants, solopreneurs, workplace trainers, HR leaders, L&D teams, and small-business owners. Whether you want to generate revenue delivering client training or reduce conflict inside your own organization, the toolkit gives you a complete, proven program to do it.",
  },
  {
    q: "Can I really rebrand and customize the materials?",
    a: "Yes. The toolkit is fully white-labeled. Download the files, add your logo, adapt the language and examples to your audience or industry, and deliver it as your own program — as many times as you want.",
  },
  {
    q: "Do I need facilitation or training experience?",
    a: "No. The facilitator's guide walks you through delivering the two-hour session step by step — including how to create psychological safety and handle challenging learner moments — and the tutorial videos let you learn directly from facilitators who have delivered this program hundreds of times.",
  },
  {
    q: "Is this the same program Civility Partners delivers for $10,000?",
    a: "Yes. These are the same slides, participant materials, and facilitation approach Civility Partners uses in its own client engagements — packaged so you can deliver the training yourself, on your schedule, for a one-time $249.",
  },
  {
    q: "How many times can I use it?",
    a: "Unlimited. It's a one-time purchase with unlimited reuse — train every client, team, or location you serve without paying again.",
  },
  {
    q: "How do I receive the materials?",
    a: "Instantly after purchase. You'll get immediate access to download the welcome packet, upfront summary, training slides, participant workbook, tutorial videos, FAQ video, and office-hours recording — plus a certificate of completion when you finish the course.",
  },
];

export const FAQ = () => (
  <section id="faq" className="bg-cream-dark py-24 lg:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">Questions, answered</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          Everything you're wondering before you buy.
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-12">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-navy/10">
              <AccordionTrigger data-testid={`faq-question-${i + 1}`} className="text-left font-display text-lg font-bold tracking-tight hover:text-terra hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i + 1}`} className="leading-relaxed text-navy/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal className="mt-12">
        <BuyButton testId="faq-buy-button" size="lg">Get the Toolkit — $249</BuyButton>
      </Reveal>
    </div>
  </section>
);
